import isType from './is-type';

var isDate = function (value) {
  return isType(value, 'Date');
};

export default isDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-date.js
// module id = 83
// module chunks = 0